<div class="header">

  <!-- Management Group Notification Banner -->
  @if (showBanner && isSuperSuperAdmin) {
    <div class="management-group-banner">
      <span>
        You are viewing the {{ selectedGroup?.name }} management group.
      </span>
      <button
        mat-icon-button
        (click)="dismissBanner()"
        aria-label="Close notification">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  }

  <div class="nav">

    <div
      class="hamburger-menu"
      (click)="toggleMenu()">
      <mat-icon>menu</mat-icon>
    </div>

    <div class="logo">
      @if (!external) {
        <a
          [routerLink]="home">
          <img
            src="assets/logo.png"
            style="max-height: 30px" />
        </a>
      } @else {
        <a
          [href]="home">
          <img
            src="assets/logo.png"
            style="max-height: 30px" />
        </a>
      }
    </div>

    <div class="menu">
      <div class="menu-item">
        @if (!external) {
          <a
            [routerLink]="home"
            class="mat-primary">
            <mat-icon>home</mat-icon>
            <span>Home</span>
          </a>
        } @else {
          <a
            [href]="home"
            class="mat-primary">
            <mat-icon>home</mat-icon>
            <span>Home</span>
          </a>
        }
      </div>
      <ng-content></ng-content>
    </div>

    <div class="right-menu">

      <!-- Management Group Dropdown for Super Super Admin -->
      @if (isSuperSuperAdmin) {
        <div>
          <button
            mat-button
            (click)="openManagementGroupModal()"
            class="management-group-button"
            [ngClass]="{'own-org-button': selectedGroup?.id === userProfile?.org_id}">
            @if (selectedGroup?.id === userProfile?.org_id) {
              <mat-icon>check_circle</mat-icon>
            }
            {{ selectedGroup?.name || 'Change Management Group' }}
          </button>
        </div>
      }

      <ng-content></ng-content>

      @if (!external) {
        <button
          mat-button
          [matMenuTriggerFor]="menu"
          class="menu">
          <span>{{ userProfile?.first_name?.[0] }}</span>
          <span>{{ userProfile?.last_name?.[0] }}</span>
          <mat-icon
            iconPositionEnd>
            keyboard_arrow_down
          </mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button
            mat-menu-item
            value="profile"
            [routerLink]="profile">
            Profile
          </button>
          @if (show_settings) {
            <button
              mat-menu-item
              value="settings"
              [routerLink]="settings">
              Manage Account
            </button>
          }
          @if (isAdmin) {
            <a
              mat-menu-item
              data-testid="header-menu-admin"
              [href]="adminUrl">
              Admin
            </a>
          }
          <button
            mat-menu-item
            value="preferences"
            (click)="showPreferencesModal()">
            Preferences
          </button>
          <button
            mat-menu-item
            value="cookie-settings"
            (click)="openCookieSettings()">
            Cookie Settings
          </button>
          <button
            mat-menu-item
            value="logout"
            (click)="logout()">
            Logout
          </button>
        </mat-menu>
      } @else {
        <button
          mat-button
          [matMenuTriggerFor]="menu"
          class="menu">
          <span>{{ userProfile?.first_name?.[0] }}</span>
          <span>{{ userProfile?.last_name?.[0] }}</span>
          <mat-icon
            iconPositionEnd>
            keyboard_arrow_down
          </mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <a
            mat-menu-item
            value="profile"
            [href]="profile">
            Profile
          </a>
          @if (show_settings) {
            <a
              mat-menu-item
              value="settings"
              [href]="settings">
              Manage Account
            </a>
          }
          <a
            mat-menu-item
            value="preferences"
            (click)="showPreferencesModal()">
            Preferences
          </a>
          <button
            mat-menu-item
            value="cookie-settings"
            (click)="openCookieSettings()">
            Cookie Settings
          </button>
          <button
            mat-menu-item
            value="logout"
            (click)="logout()">
            Logout
          </button>
        </mat-menu>
      }
    </div>

    <!-- Side menu for mobile view -->
    <nav class="navbar">
      <div class="nav-menu">
        <button
          [class.active-link]="currentPath === home">
          <a [href]="home">Home</a>
        </button>
        <button
          [class.active-link]="currentUrl === ollie"
          (click)="goToOllie()">
          Ollie
        </button>
        <button
          (click)="showPreferencesModal()">
          Preferences
        </button>
        <button
          (click)="goToHelpLink()">
          Help
        </button>
        <button
          (click)="openCookieSettings()">
          Cookie Settings
        </button>
        <button
          [class.active-link]="currentPath.includes(profile)"
          (click)="goToProfile()">
          Profile
        </button>
        @if (show_settings) {
          <button
            [class.active-link]="currentPath.includes(settings)">
            <a [href]="settings">Manage Account</a>
          </button>
        }
        <button
          (click)="logout()">
          Logout
        </button>
      </div>
    </nav>

  </div>

  <div class="breadcrumbs">
    <img
      src="assets/breadcrumb-header.png" />
  </div>

</div>
